import { isChangesetApplicationValidationError } from '@festina/configuration-general-types/configuration'
import { useMemo } from 'react'

import { useOperationsContext } from '../../../../workspace/operationsContext'

export const useChangesetApplicationErrors = () => {
  const { errors } = useOperationsContext()

  return useMemo(
    () =>
      (errors ?? []).filter(({ error }) =>
        isChangesetApplicationValidationError(error),
      ),
    [errors],
  )
}
